"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeritextHeadless = void 0;
const keyboard_1 = require("@jsonjoy.com/keyboard");
const PeritextEventDefaults_1 = require("./events/defaults/PeritextEventDefaults");
const SliceRegistry_1 = require("./registry/SliceRegistry");
const PeritextEventTarget_1 = require("./events/PeritextEventTarget");
const PeritextClipboardImpl_1 = require("./events/clipboard/PeritextClipboardImpl");
const create_1 = require("./transfer/create");
const PeritextCommands_1 = require("./commands/PeritextCommands");
const Annals_1 = require("./annals/Annals");
const tree_dump_1 = require("tree-dump");
const Log_1 = require("../../json-crdt/log/Log");
class PeritextHeadless {
    constructor(txt, opts = {}) {
        this.txt = txt;
        this._kbdUnbind = void 0;
        const { log = Log_1.Log.from(txt.model) } = opts;
        const registry = new SliceRegistry_1.SliceRegistry();
        const transfer = (0, create_1.create)(txt, registry);
        const et = new PeritextEventTarget_1.PeritextEventTarget();
        const clipboard = new PeritextClipboardImpl_1.PeritextClipboardImpl(navigator.clipboard);
        const defaults = new PeritextEventDefaults_1.PeritextEventDefaults(txt, et, { clipboard, transfer });
        et.defaults = defaults;
        const cmd = new PeritextCommands_1.PeritextCommands(txt, et);
        const annals = new Annals_1.Annals(log, txt, et);
        defaults.undo = annals;
        let { kbd } = opts;
        if (kbd) {
            kbd = kbd.child('peritext-headless');
            this._kbdUnbind = () => kbd.dispose();
        }
        else {
            const [kbd0, unbindSource] = keyboard_1.KeyContext.global('peritext-headless', { filter: 'no-inputs' });
            kbd = kbd0;
            this._kbdUnbind = () => {
                unbindSource();
                kbd0.dispose();
            };
        }
        kbd.focus();
        this.kbd = kbd;
        this.log = log;
        this.registry = registry;
        this.transfer = transfer;
        this.et = et;
        this.clipboard = clipboard;
        this.defaults = defaults;
        this.cmd = cmd;
        this.annals = annals;
    }
    /** -------------------------------------------------- {@link UiLifeCycles} */
    start() {
        const stopAnnals = this.annals.start();
        return () => {
            stopAnnals();
            this._kbdUnbind?.();
        };
    }
    /** ----------------------------------------------------- {@link Printable} */
    toString(tab) {
        return ('Headless' +
            (0, tree_dump_1.printTree)(tab, [
                (tab) => this.registry.toString(tab),
                (tab) => this.annals.toString(tab),
                (tab) => this.kbd.toString(tab),
                (tab) => this.txt.toString(tab),
            ]));
    }
}
exports.PeritextHeadless = PeritextHeadless;
